import { axiosProfileInstance } from "../AxiosConfiguration";

const unwrap = (res) => {
  const data = res?.data;
  if (data && typeof data === "object") return data.payload ?? data;
  return data;
};

// Update coaching mode: 'voice' | 'keyboard'
export async function updateCoachingMode(mode) {
  const body = { coaching_mode: mode };
  const res = await axiosProfileInstance.put("/api/user/settings/coaching-mode", body);
  const val = unwrap(res);
  try { localStorage.setItem("coaching_mode", String(mode)); } catch (_) {}
  return val;
}

// Mark voice walkthrough status
export async function setVoiceWalkthrough(done) {
  const body = { done };
  const res = await axiosProfileInstance.put("/api/user/settings/walkthrough/voice", body);
  return unwrap(res);
}

// Mark keyboard walkthrough status
export async function setKeyboardWalkthrough(done) {
  const body = { done };
  const res = await axiosProfileInstance.put("/api/user/settings/walkthrough/keyboard", body);
  return unwrap(res);
}

// Notification preferences live on the user_settings document in core-lambda,
// which is the source of truth (see docs/navigation-redesign-plan.md §5.3).
// Today it exposes: general, invite, coach, email_comm, push_notifications.
export async function getNotificationSettings() {
  const res = await axiosProfileInstance.get("/api/user/settings/notifications");
  return unwrap(res);
}

// Partial update — send only the fields that changed.
export async function updateNotificationSettings(updates) {
  const res = await axiosProfileInstance.put(
    "/api/user/settings/notifications",
    updates
  );
  return unwrap(res);
}

export function getCoachingMode() {
  try {
    const v = localStorage.getItem("coaching_mode");
    if (v === "voice" || v === "keyboard") return v;

    const profile = JSON.parse(localStorage.getItem("profile") || "null");
    const modeFromMeta = profile?.meta_info?.settings?.coaching_mode;
    if (modeFromMeta === "voice" || modeFromMeta === "keyboard") return modeFromMeta;

    if (profile?.meta_info?.settings?.voice_mode === true) return "voice";

    const topLevel = profile?.coaching_mode;
    if (topLevel === "voice" || topLevel === "keyboard") return topLevel;
  } catch (_) {}
  return "keyboard"; // default fallback
}
